import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Loader from 'components/Loader';
import { colors } from 'styles/colors';
import { devices } from 'styles/devices';
import Slides from './Slides';

const News = () => {
   const [posts, setPosts] = useState(null);
   const [loading, setLoading] = useState(true);
   const lang = useSelector((state) => state.app.lang);

   useEffect(() => {
      setLoading(true);

      axios
         .get(`/wp/v2/posts`, {
            params: {
               per_page: 5,
               // TODO TRANSLATION: change category for english translation
               categories: lang === 'eng' ? 119 : 119, // Aktualności
               _embed: true
            }
         })
         .then(({ data }) => {
            const postsList = data.map((post) => {
               // eslint-disable-next-line no-prototype-builtins
               const background = post._embedded.hasOwnProperty('wp:featuredmedia')
                  ? post._embedded['wp:featuredmedia'][0]?.source_url
                  : '';

               return {
                  id: post.id,
                  title: post.title.rendered,
                  content: post.excerpt.rendered,
                  background
               };
            });

            setPosts(postsList);
         })
         .finally(() => {
            setLoading(false);
         });
   }, [lang]);

   if (loading) {
      return (
         <LoaderWrapper>
            <Loader />
         </LoaderWrapper>
      );
   }

   if (!posts) {
      return null;
   }

   return (
      <div>
         <Title>
            <FormattedMessage id="News" />
         </Title>
         <Slides posts={posts} />
      </div>
   );
};

const Title = styled.h1`
   color: ${colors.white};
   font-weight: 700;
   margin-bottom: 1rem;
   font-size: 2rem;

   ${devices.mobileL} {
      margin-bottom: 1.5rem;
   }

   ${devices.tabletL} {
      font-size: 3.8rem;
      margin-bottom: 3rem;
   }
`;

const LoaderWrapper = styled.div`
   position: relative;
   height: 100px;
   margin-bottom: 100px;
`;

export default News;
